"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductCarouselPwa = void 0;

var _react = _interopRequireDefault(require("react"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _compact = _interopRequireDefault(require("lodash/compact"));

var _useProducts2 = require("./hooks/useProducts");

var _useWishlist2 = require("./hooks/useWishlist");

var _productCarouselUi = _interopRequireDefault(require("./product-carousel-ui"));

var _useToasts2 = require("../../hooks/useToasts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProductCarouselPwa = function ProductCarouselPwa(_ref) {
  var _ref$products = _ref.products,
      productIds = _ref$products === void 0 ? [] : _ref$products,
      tools = _ref.tools,
      otherProps = _objectWithoutProperties(_ref, ["products", "tools"]);

  var _useToasts = (0, _useToasts2.useToasts)(),
      toasts = _useToasts.toasts,
      api = _useToasts.api;

  var _tools$context$useUse = tools.context.useUserContext(),
      _tools$context$useUse2 = _slicedToArray(_tools$context$useUse, 1),
      isSignedIn = _tools$context$useUse2[0].isSignedIn;

  var ids = (0, _uniq.default)(productIds.map(function (item) {
    return item.skuNumber && item.skuNumber.toUpperCase();
  }));
  var variantIDs = (0, _compact.default)(productIds.map(function (item) {
    return item.simpleSkuNumber && item.simpleSkuNumber.toUpperCase();
  }));

  var _useProducts = (0, _useProducts2.useProducts)(ids, variantIDs),
      products = _useProducts.products;

  var _useWishlist = (0, _useWishlist2.useWishlist)(api),
      favorites = _useWishlist.favorites,
      updateFavoriteWishlistState = _useWishlist.updateFavoriteWishlistState;

  var toggleFavorites = function toggleFavorites(id, isWishlisted) {
    if (!id) return;
    updateFavoriteWishlistState(id, isWishlisted);
  };

  var sortedProducts = products.length ? productIds.map(function (_ref2) {
    var sku = _ref2.skuNumber,
        simpleSkuNumber = _ref2.simpleSkuNumber;
    return _objectSpread({
      simpleSkuNumber: simpleSkuNumber
    }, products.filter(function (item) {
      return item.sku === sku.toUpperCase();
    })[0]);
  }).filter(function (item) {
    return !!item.sku;
  }) : [];
  return /*#__PURE__*/_react.default.createElement(_productCarouselUi.default, _extends({
    toasts: toasts,
    products: sortedProducts,
    favorites: favorites,
    isSignedIn: isSignedIn,
    handleToggleFavorites: toggleFavorites
  }, otherProps));
};

exports.ProductCarouselPwa = ProductCarouselPwa;
var _default = ProductCarouselPwa;
exports.default = _default;